import { __awaiter } from "tslib";
import { CheckoutVersion } from '../CheckoutAPI';
import { axiosClient } from '@as-react/common-utils';
const buyEndpoints = {
    delivery: 'api/buy/delivery',
    deliveryOption: 'api/buy/delivery/option',
    namedDayDeliveryDays: 'api/nameddaydelivery/deliverydays',
    searchPointsByPostcode: 'api/pickup/postcode',
    searchPointsByGeoLocation: 'api/pickup/geolocation',
    savePoint: 'api/buy/pickup/v2',
    collectInStore: 'api/buy/delivery/clickandcollect',
    contact: 'api/buy/contact',
    payment: 'api/buy/payment',
    postPayment: 'api/buy/payment/v2',
    paymentProviderInput: 'api/buy/input',
    paymentOption: 'api/buy/payment/option',
    paymentOptions: 'api/buy/payment/options',
    voucherCodeSend: 'api/checkout/voucher',
    paymentSaferpayAlt: 'api/buy/input/saferpay/alternative',
    paymentStatusSaferpayAlt: 'api/buy/status/saferpay/alternative',
    paymentSaferpayToken: 'api/buy/input/saferpay/token',
    paymentProviderPlaceOrder: 'api/buy/submit',
    orderPaidByVoucher: 'api/buy/payment/voucher',
    confirmation: 'api/buy/done',
    analyticsPurchaseStep: 'api/analytics/purchasestep',
    dtmAnalyticsPurchaseStep: 'api/dtm/purchasestep',
    paymentSaferpayAlias: 'api/buy/input/saferpay/alias',
    shoplandingPayment: 'api/buy/landing',
    paymentEnabled: 'api/buy/payment/enabled',
    paymentRequestConfirmation: 'api/checkout/paymentrequest/done',
};
class BuyApi {
    constructor() {
        this.postDeliveryOption = (servicesApi, defaultRequestParams, deliveryOption) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.deliveryOption}/${deliveryOption}`,
                params: defaultRequestParams,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getNamedDayDeliveryDates = (servicesApi, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.namedDayDeliveryDays}`,
                params: Object.assign({}, defaultRequestParams),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.searchPickupPoints = (servicesApi, postcode, provider, countryCode, deliveryDate, limit) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.searchPointsByPostcode}`,
                params: { postcode, provider, countryCode, deliveryDate, limit },
                withCredentials: true,
            };
            return yield axiosClient.request(axiosConfig);
        });
        this.searchPickupPointsByGeoLocation = (servicesApi, provider, countryCode, deliveryDate, radius, limit, latitude, longitude) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.searchPointsByGeoLocation}`,
                params: { provider, countryCode, deliveryDate, radius, limit, latitude, longitude },
                withCredentials: true,
            };
            return yield axiosClient.request(axiosConfig);
        });
        this.postDelivery = (servicesApi, defaultRequestParams, delivery) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.delivery}`,
                params: defaultRequestParams,
                withCredentials: true,
                data: delivery,
            };
            yield axiosClient.request(axiosConfig);
        });
        this.getStoresForGeoLocation = (servicesApi_1, defaultRequestParams_1, _a, size_1, onlyInStock_1, ...args_1) => __awaiter(this, [servicesApi_1, defaultRequestParams_1, _a, size_1, onlyInStock_1, ...args_1], void 0, function* (servicesApi, defaultRequestParams, { latitude, longitude }, size, onlyInStock, fasciaFirst = false) {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.collectInStore}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { latitude, longitude, size, onlyInStock, fasciaFirst }),
                withCredentials: true,
            };
            const answer = yield axiosClient.request(axiosConfig);
            return answer.data;
        });
        this.updateCustomerData = (servicesApi, defaultRequestParams, customerDetails) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.contact}`,
                params: defaultRequestParams,
                withCredentials: true,
                data: customerDetails,
            };
            yield axiosClient.request(axiosConfig);
        });
        this.getPayment = (servicesApi, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.payment}`,
                params: defaultRequestParams,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.postPayment = (servicesApi, defaultRequestParams, payment) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.postPayment}`,
                params: defaultRequestParams,
                withCredentials: true,
                data: payment,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.paymentProviderInputRequest = (servicesApi, defaultRequestParams, provider, data, params) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.paymentProviderInput}/${provider.toLowerCase()}`,
                params: Object.assign(Object.assign(Object.assign({}, defaultRequestParams), params), { checkoutVersion: CheckoutVersion.NEW }),
                withCredentials: true,
                data,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.updatePaymentId = (servicesApi, defaultRequestParams, paymentOptionId) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.paymentOption}/${paymentOptionId}`,
                params: defaultRequestParams,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.paymentProviderPlaceOrder = (apiEndpoint, defaultRequestParams, provider, authorizationToken) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { authorizationToken, checkoutVersion: CheckoutVersion.NEW }),
                url: `${apiEndpoint}${buyEndpoints.paymentProviderPlaceOrder}/${provider}`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.orderPaidByVoucher = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}${buyEndpoints.orderPaidByVoucher}`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getConfirmedOrder = (servicesApi, defaultRequestParams, orderRef, customerId) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.confirmation}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { orderRef, customerID: customerId }),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getAnalyticsPurchaseStepInformation = (servicesApi, defaultRequestParams, orderID) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.analyticsPurchaseStep}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { orderID }),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getDtmAnalyticsPurchaseStepInformation = (servicesApi, defaultRequestParams, orderID) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.dtmAnalyticsPurchaseStep}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { orderID }),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.shoplandingPayment = (servicesApi, defaultRequestParams, shopNumber) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${buyEndpoints.shoplandingPayment}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { shopNumber, physicalShop: true }),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getPaymentOptions = (servicesApi_1, _a, paymentOptionGroup_1) => __awaiter(this, [servicesApi_1, _a, paymentOptionGroup_1], void 0, function* (servicesApi, { shopId, mainWebshop }, paymentOptionGroup) {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.paymentOptions}/${paymentOptionGroup}`,
                params: {
                    fictiveWebShopId: shopId,
                    mainWebShop: mainWebshop,
                },
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getPaymentRequestConfirmation = (servicesApi, paymentRequestId, anaLang, language, mainWebshop, market, shopId) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${buyEndpoints.paymentRequestConfirmation}`,
                params: { paymentRequestId, anaLang, language, mainWebshop, market, shopId },
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new BuyApi();
